import React from 'react';
import {safeHtml} from '@helper/sanitize-html';

const PopupAboutUs = ({type, title, content, image, onClose}) => {
    return (
        <div className="popup-overlay">
            <div className="popup-container">
                <img src={image} alt="popup visual" />
                <div className="popup-text">
                    <div className="popup-header">
                        <div>
                            {type === 'vision' && (
                                <img src="/bw_image/ic_vision.png" alt="mision" className="popup-icon" />
                            )}
                            {type === 'mission' && (
                                <img src="/bw_image/ic_mission.png" alt="vision" className="popup-icon" />
                            )}
                            {type === 'thanks' && <></>}
                        </div>
                        <div className="popup-content-desc">
                            <h2 className={type === 'vision' ? 'vision-title' : 'mission-title'}>{title}</h2>

                            <div className="popup-content">
                                <p
                                    dangerouslySetInnerHTML={safeHtml(content)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="popup-image">
                    <button className="popup-close" onClick={onClose}>
                        <img src="/bw_image/ic_close_white.png"></img>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopupAboutUs;
